import axios from 'axios';
import store from '../store/store.js';

let http = axios.create({
	//baseURL: 'http://localhost:8081/zhongxinbaocheng/public/index.php?s=api',
	baseURL: window.config.api,
	timeout: 5000,
	withCredentials: process.env.NODE_ENV === 'development' ? false : true,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	},
	transformRequest: [function(data) {
		let newData = '';
		for (let k in data) {
			if (Object.prototype.hasOwnProperty.call(data, k) === true) {
				newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
			}
		}
		return newData;
	}]
});
http.interceptors.request.use(
	config => {
		const token = localStorage.getItem("token")
		//window.console.log(token)
		if (token) {
			config.headers.accessToken = token;
		}
		return config
	},
	error => {
		return Promise.error(error)
	})
http.interceptors.response.use(response => {
		let app = store.store.state.app
		if (response.data.token) {
			return response.data
		} else {
			app.$toast('token错误!请刷新页面')
		}
	},
	error => {
		return Promise.reject(error)
	})

function apiAxios(method, url, params, response, reject) {
	let app = store.store.state.app
	http({
		method: method,
		url: url,
		data: method === 'POST' || method === 'PUT' ? params : null,
		params: method === 'GET' || method === 'DELETE' ? params : null,
	}).then(function(res) {
		if (res && res.success) {
			response(res.data)
		} else {
			if (res && res.msg) {
				app.$toast(res.msg)
			}
			reject(res.msg)
		}
	}).catch(function(err) {
		if (err.message.includes('timeout')) {
			app.$toast('请求超时')
		}
		reject(err.message)
	})
}

export default {
	get(url, params, response,reject) {
		return apiAxios('GET', url, params, response, reject)
	},
	post(url, params, response,reject) {
		return apiAxios('POST', url, params, response, reject)
	},
	put(url, params, response,reject) {
		return apiAxios('PUT', url, params, response, reject)
	},
	delete(url, params, response,reject) {
		return apiAxios('DELETE', url, params, response, reject)
	}
}
